var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterMask({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 479,
    viewBox: "0 0 1440 479",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.572021V478.331H1440V0.295898C1237.3 56.3231 988.453 89.3306 719.5 89.3306C450.989 89.3306 202.516 56.4316 0 0.572021Z",
    fill: "#F0F0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.572021V478.331H1440V0.295898C1237.3 56.3231 988.453 89.3306 719.5 89.3306C450.989 89.3306 202.516 56.4316 0 0.572021Z",
    fill: "#E8B64A",
    fillOpacity: 0.05
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterMask);
export default __webpack_public_path__ + "static/media/footer_mask.e31ae9e9ba0a7bee1c48d451acdec28b.svg";
export { ForwardRef as ReactComponent };